import type { FaireProductEntity } from "../../entity_types/product";

export const p_8zc4pppspq: FaireProductEntity = {
  token: "p_8zc4pppspq",
  type: "product",
  name: "Little Book of Fika by Lynda  Balslev",
  brandToken: "b_7a909d43",
  brandName: "Simon & Schuster",
  imageUrl:
    "https://cdn.faire.com/fastly/86244f0ea8b25daf54a8ca453408315f7e99dad9c03b6d0df289a938d7d1115e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e3efd8e2ebbb1c4f76b19413d6f217e1b55338c06ff88d714f9a9b570e24e087.jpeg",
    "https://cdn.faire.com/fastly/52c02e518e2e86bae990e138a9cfd52f57dd8577773949ddb93971261535df22.jpeg",
    "https://cdn.faire.com/fastly/4afbbfa8909db93acdf55bc3702052f4735c0249d8a083794979f251cbcfc136.jpeg",
    "https://cdn.faire.com/fastly/4c6e1fb581f97b3e0dd01830b2321b02a7f0b7af1c0f7ff5853bd68f5962a0c6.jpeg",
    "https://cdn.faire.com/fastly/338d5dc5241335fb8738051fe8a0f4f34be720a863df0939a4ececc84aa68985.jpeg",
    "https://cdn.faire.com/fastly/23cb9adffa5c387e800daa0cfb4327845e3bec1e3e06dc956550cb0e468ef6dd.jpeg",
  ],
  priceDollars: 5,
  description:
    "[AMP]\r\n\r\nA little book on the Swedish tradition of fika—the twice-daily coffee break —with recipes, fun facts, and quotes.\r\n\r\nAs the Danish concept of hygge has caught on around the globe, so has lagom, its Swedish counterpart. An essential part of the lagom lifestyle, fika is the simple art of taking a break—sometimes twice a day—to enjoy a warm beverage and sweet treat with friends, creating a mindful and stress-relieving pause in your day that has significant benefits for your energy, contentment, and even productivity.\r\n\r\nA delightful, compact-sized gift book, The Little Book of Fika offers an introduction to the fika tradition with wisdom and recipes to help you establish your own practice and rituals.\r\n\r\nIncludes:\r\n- An overview of the concepts of fika and lagom \r\n- Quotes celebrating the joys of good coffee, good friends, and appreciating the simple pleasures in life \r\n- 20 sweet and savory recipes, including elderflower cordial, cardamom buns with almond cream filling, apple cake, Swedish butter cookies, and open-face shrimp sandwiches\r\n\r\nA lovely gift or self-purchase for anyone looking for simple stress relief and connection.",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:49.637Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
